import { gradeFilterFactory } from '@/catalog/constants/filterInputMeta/gradeFilterFactory';

export default gradeFilterFactory({
  id: 'integralV2.gmc',
  name: 'Global Performance v2 (Beta)',
  getter(filters) {
    return filters.integralV2Gmc;
  },
  setter(value, filters) {
    return filters.setIntegralV2Gmc(value);
  },
});
